module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_j_leucistic.27a27cb1.png";